module.exports = __webpack_public_path__ + "img/wsczzhjkyypt14.8ded985c.png";